import React from 'react';

const ListItem = ({ tone, text }) => (
  <li className={`rounded-md border px-2 py-1.5 text-xs ${tone}`}>{text}</li>
);

const RecoveryBlockersPanel = ({ blockers = [], warnings = [] }) => {
  const safeBlockers = Array.isArray(blockers) ? blockers : [];
  const safeWarnings = Array.isArray(warnings) ? warnings : [];

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Blockers & Warnings</h3>
      <div className="mt-3 grid gap-3 xl:grid-cols-2">
        <div>
          <p className="mb-2 text-xs font-semibold uppercase tracking-[0.08em] text-red-300">Blockers</p>
          <ul className="space-y-2">
            {safeBlockers.length ? safeBlockers.map((item, idx) => (
              <ListItem key={`block-${idx}`} tone="border-red-500/40 bg-red-500/10 text-red-200" text={item} />
            )) : <ListItem tone="border-emerald-500/40 bg-emerald-500/10 text-emerald-200" text="Tidak ada blocker aktif." />}
          </ul>
        </div>
        <div>
          <p className="mb-2 text-xs font-semibold uppercase tracking-[0.08em] text-amber-300">Warnings</p>
          <ul className="space-y-2">
            {safeWarnings.length ? safeWarnings.map((item, idx) => (
              <ListItem key={`warn-${idx}`} tone="border-amber-500/40 bg-amber-500/10 text-amber-200" text={item} />
            )) : <ListItem tone="border-slate-700 bg-slate-950/70 text-slate-300" text="Tidak ada warning aktif." />}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default RecoveryBlockersPanel;
